<template>
  <DailyStatementDetail />
</template>

<script>

import DailyStatementDetail from '@components/content/daily-statement-detail.vue'

export default {
  components: {
    DailyStatementDetail
  },
  head () {
    return {
      link: [
        {
          type: 'text/css',
          rel: 'stylesheet',
          href: '/styles/statement.css'
        },
      ],
    };
  },
}
</script>


<style>
#app{
 background: #45464E;
 font-size: 12px;
}

.popper {
  width: auto;
  background-color: #fafafa;
  color: #212121;
  text-align: center;
  padding: 2px;
  display: inline-block;
  border-radius: 3px;
  position: absolute;
  font-size: 14px;
  font-weight: normal;
  border: 1px #ebebeb solid;
  z-index: 200000;
  -moz-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
  -webkit-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
  box-shadow: rgb(58, 58, 58) 0 0 6px 0;
}

.popper .popper__arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
}

.popper[x-placement^="top"] {
  margin-bottom: 5px;
}

.popper[x-placement^="top"] .popper__arrow {
  border-width: 5px 5px 0 5px;
  border-color: #fafafa transparent transparent transparent;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.popper[x-placement^="bottom"] .popper__arrow {
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #fafafa transparent;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.popper[x-placement^="right"] {
  margin-left: 5px;
}

.popper[x-placement^="right"] .popper__arrow {
  border-width: 5px 5px 5px 0;
  border-color: transparent #fafafa transparent transparent;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.popper[x-placement^="left"] {
  margin-right: 5px;
}

.popper[x-placement^="left"] .popper__arrow {
  border-width: 5px 0 5px 5px;
  border-color: transparent transparent transparent #fafafa;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.daterangepicker td.available:hover,
        .daterangepicker th.available:hover,
        .ranges li {
            background-color: #f0f6ff
        }

        .datepicker td,
        .datepicker th {
            font-weight: 400;
            font-size: 14px;
            color: #617182
        }

        .datepicker table tr td.new,
        .datepicker table tr td.old,
        .daterangepicker td.off,
        .daterangepicker td.off.end-date,
        .daterangepicker td.off.in-range,
        .daterangepicker td.off.start-date {
            color: #CCD9E9
        }

        .datepicker-dropdown {
            margin: .5rem 0 0;
            border: none;
            box-shadow: 0 4px 14px rgba(174, 197, 231, .5);
            font-size: .875rem
        }

        .datepicker-dropdown:before {
            border-bottom-color: #fff
        }

        .datepicker td,
        .datepicker th {
            width: 25px;
            height: 25px;
            text-align: center;
            border-radius: 4px;
            border: none
        }

        .datepicker-inline,
        .note-editor.note-frame {
            border: 1px solid #f0f6ff
        }

        .datepicker,
        .datetimepicker {
            z-index: 12000;
            width: 260px;
            padding: 10px
        }

        .datepicker table,
        .datetimepicker table,
        .dt-cont {
            width: 100%
        }

        .dt-cont {
            position: relative;
            height: 400px;
            margin: 0;
            padding: 0;
            border: 1px solid #ccc
        }

        .datepicker table tr td.active,
        .datepicker table tr td.active.disabled,
        .datepicker table tr td.active.disabled:hover,
        .datepicker table tr td.active:hover,
        .datetimepicker table tr td span.active.active,
        .datetimepicker table tr td span.active.disabled.active,
        .datetimepicker table tr td span.active.disabled:active,
        .datetimepicker table tr td span.active.disabled:hover.active,
        .datetimepicker table tr td span.active.disabled:hover:active,
        .datetimepicker table tr td span.active:active,
        .datetimepicker table tr td span.active:hover.active,
        .datetimepicker table tr td span.active:hover:active,
        .datetimepicker table tr td.active,
        .datetimepicker table tr td.active.disabled,
        .datetimepicker table tr td.active.disabled:hover,
        .datetimepicker table tr td.active:hover {
            background-image: none;
            text-shadow: none
        }

        .datepicker .datepicker-switch:hover,
        .datepicker .next:hover,
        .datepicker .prev:hover,
        .datepicker table tr td.day.focused,
        .datepicker table tr td.day:hover,
        .datepicker tfoot tr th:hover,
        .datetimepicker table tr td span:hover,
        .datetimepicker table tr td.day:hover,
        .datetimepicker tfoot tr:first-child th:hover,
        .datetimepicker thead tr:first-child th:hover {
            background: #f0f6ff
        }

        .bootstrap-timepicker table td a:hover {
            border-color: #f0f6ff;
            border-radius: 4px;
            background-color: #f0f6ff
        }

        .bootstrap-timepicker table td input {
            width: 35px;
            border: 1px solid #f0f6ff
        }

        .daterangepicker td,
        .daterangepicker th {
            font-size: .875rem
        }

        .daterangepicker .input-mini {
            border: 1px solid rgba(141, 166, 195, .3)
        }

        .daterangepicker select.ampmselect,
        .daterangepicker select.hourselect,
        .daterangepicker select.minuteselect,
        .daterangepicker select.monthselect,
        .daterangepicker select.yearselect {
            border: 1px solid #dfe7f3;
            background: #f0f6ff;
            color: #7d93b7;
            font-size: 12px;
            padding: 5px 10px
        }

        .daterangepicker select.ampmselect,
        .daterangepicker select.hourselect,
        .daterangepicker select.minuteselect,
        .daterangepicker select.secondselect {
            height: 25px
        }

        .daterangepicker.dropdown-menu {
            box-shadow: 0 4px 14px rgba(174, 197, 231, .5);
            border: 1px solid rgba(141, 166, 195, .3)
        }

        .ranges li {
            border: 1px solid #f0f6ff
        }

        @-webkit-keyframes passing-through {
            0% {
                opacity: 0;
                -webkit-transform: translateY(40px);
                transform: translateY(40px)
            }

            30%,
            70% {
                opacity: 1;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }

            100% {
                opacity: 0;
                -webkit-transform: translateY(-40px);
                transform: translateY(-40px)
            }
        }

        @keyframes passing-through {
            0% {
                opacity: 0;
                -webkit-transform: translateY(40px);
                transform: translateY(40px)
            }

            30%,
            70% {
                opacity: 1;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }

            100% {
                opacity: 0;
                -webkit-transform: translateY(-40px);
                transform: translateY(-40px)
            }
        }

        @-webkit-keyframes slide-in {
            0% {
                opacity: 0;
                -webkit-transform: translateY(40px);
                transform: translateY(40px)
            }

            30% {
                opacity: 1;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }
        }

        @keyframes slide-in {
            0% {
                opacity: 0;
                -webkit-transform: translateY(40px);
                transform: translateY(40px)
            }

            30% {
                opacity: 1;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }
        }

        @-webkit-keyframes pulse {

            0%,
            20% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }

            10% {
                -webkit-transform: scale(1.1);
                transform: scale(1.1)
            }
        }

        @keyframes pulse {

            0%,
            20% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }

            10% {
                -webkit-transform: scale(1.1);
                transform: scale(1.1)
            }
        }

        .datepicker table tr td.active.active,
        .datepicker table tr td.active.disabled,
        .datepicker table tr td.active.disabled.active,
        .datepicker table tr td.active.disabled.disabled,
        .datepicker table tr td.active.disabled:active,
        .datepicker table tr td.active.disabled:hover,
        .datepicker table tr td.active.disabled:hover.active,
        .datepicker table tr td.active.disabled:hover.disabled,
        .datepicker table tr td.active.disabled:hover:active,
        .datepicker table tr td.active.disabled:hover:hover,
        .datepicker table tr td.active.disabled:hover[disabled],
        .datepicker table tr td.active.disabled[disabled],
        .datepicker table tr td.active:active,
        .datepicker table tr td.active:hover,
        .datepicker table tr td.active:hover.active,
        .datepicker table tr td.active:hover.disabled,
        .datepicker table tr td.active:hover:active,
        .datepicker table tr td.active:hover:hover,
        .datepicker table tr td.active:hover[disabled],
        .datepicker table tr td.active[disabled],
        .datepicker table tr td.today.active,
        .datepicker table tr td.today.disabled,
        .datepicker table tr td.today.disabled.active,
        .datepicker table tr td.today.disabled.disabled,
        .datepicker table tr td.today.disabled:active,
        .datepicker table tr td.today.disabled:hover,
        .datepicker table tr td.today.disabled:hover.active,
        .datepicker table tr td.today.disabled:hover.disabled,
        .datepicker table tr td.today.disabled:hover:active,
        .datepicker table tr td.today.disabled:hover:hover,
        .datepicker table tr td.today.disabled:hover[disabled],
        .datepicker table tr td.today.disabled[disabled],
        .datepicker table tr td.today:active,
        .datepicker table tr td.today:hover,
        .datepicker table tr td.today:hover.active,
        .datepicker table tr td.today:hover.disabled,
        .datepicker table tr td.today:hover:active,
        .datepicker table tr td.today:hover:hover,
        .datepicker table tr td.today:hover[disabled],
        .datepicker table tr td.today[disabled],
        .datetimepicker table tr td span.active.active,
        .datetimepicker table tr td span.active.disabled.active,
        .datetimepicker table tr td span.active.disabled:active,
        .datetimepicker table tr td span.active.disabled:hover.active,
        .datetimepicker table tr td span.active.disabled:hover:active,
        .datetimepicker table tr td span.active:active,
        .datetimepicker table tr td span.active:hover.active,
        .datetimepicker table tr td span.active:hover:active,
        .datetimepicker table tr td.active.active,
        .datetimepicker table tr td.active.disabled.active,
        .datetimepicker table tr td.active.disabled:active,
        .datetimepicker table tr td.active.disabled:hover.active,
        .datetimepicker table tr td.active.disabled:hover:active,
        .datetimepicker table tr td.active:active,
        .datetimepicker table tr td.active:hover.active,
        .datetimepicker table tr td.active:hover:active {
            background: #2B59B4;
            color: #fff;
        }
body {
  background: #45464e;
  height: 100vh;
  font-size: 10px;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: left;
}

.tablestyle thead th {
  background: #37405a;
  color: #b0bfd3;
  font-weight: normal;
  /*border-left: 1px solid #4A82F0;
  border-bottom: 1px solid #4A82F0;*/
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4d4f5c;
}

.tablestyle .currency {
  text-align: right;
}

.tablestyle tbody tr td {
}

.tablestyle tbody tr:nth-of-type(2n + 0) td {
  background: #e3ecfe;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

body {
  background: #45464e url('/images/background.jpg') no-repeat fixed;
  background-size: cover;
}

.top-navbar {
  text-align: center;
  background: #292a2e;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #fff;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #fff;
  text-decoration: none;
}

.day-filter {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 32px;
  line-height: 32px;
  width: 100%;
  overflow: hidden;
}

.day-filter-cont {
  width: 100%;
  height: 51px;
  overflow: hidden;
  overflow-x: scroll;
  padding-bottom: 17px;
  padding-right: 17px;
}

.day-filter-butt {
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0 5px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  display: block;
  border-radius: 4px;
  font-size: 11px;
  margin-right: 10px;
  float: left;
}

.day-filter-butt.active,
.day-filter-butt:hover {
  text-decoration: none;
  color: #fff;
  background: #11487e;
  background: -moz-linear-gradient(left, #11487e 0%, #1d8af2 100%);
  background: -webkit-linear-gradient(left, #11487e 0%, #1d8af2 100%);
  background: linear-gradient(to right, #11487e 0%, #1d8af2 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#11487E', endColorstr='#1D8AF2',GradientType=1 );
  border-color: transparent;
}

span.day-filter-butt {
  border-color: transparent;
  background: rgba(0, 0, 0, 0.2);
}

span.day-filter-butt:hover {
  border-color: transparent;
  background: rgba(0, 0, 0, 0.2);
}

.balancetxt > span {
  color: #4ebaf1;
}

.dotted {
  border-bottom: 1px dotted #fff;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.lrspan span {
  display: inline-block;
}

.lrspan span:nth-child(1) {
  text-align: left;
}

.lrspan span:nth-child(2) {
  text-align: right;
}

a.statement-card {
  color: #313a47;
  background: #fff;
  padding: 6px;
  border-radius: 4px;
  display: block;
  margin-top: 10px;
  font-weight: bold;
  font-size: 12px;
}
a.statement-card:hover {
  color: #313a47;
}
a.statement-card table td{
  color: #313a47;
}
.statement-card:hover {
  color: #313a47;
}

.popover {
  background: rgb(71, 65, 64);
  border-color: rgb(71, 65, 64);
}

.bs-popover-bottom .arrow::before {
  border-bottom-color: rgb(71, 65, 64);
}
.bs-popover-auto[x-placement^="top"] .arrow::after,
.bs-popover-top .arrow::after {
  border-top-color: transparent;
}

.bs-popover-auto .arrow::after,
.bs-popover-bottom .arrow::after {
  border-color: transparent;
}

/* new start */
/* ATOM */
.resulttype1 .theresult {
  width: 250px;
  height: auto;
  background: #303f65;
  padding: 10px;
  border-radius: 10px;
}

.resulttype1 .draw-cont {
  border-radius: 10px;
  background: #00356f;
  width: 184px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  margin-bottom: 5px;
}

.resulttype1 .numtiles-cont {
  width: 184px;
  height: 184px;
  padding: 4px;
  background: rgb(64, 107, 213);
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzQwNmJkNSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMzNDljZmIiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
  background: -moz-linear-gradient(top, rgba(64, 107, 213, 1) 0%, rgba(52, 156, 251, 1) 100%);
  background: -webkit-linear-gradient(top, rgba(64, 107, 213, 1) 0%, rgba(52, 156, 251, 1) 100%);
  background: linear-gradient(to bottom, rgba(64, 107, 213, 1) 0%, rgba(52, 156, 251, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#406bd5', endColorstr='#349cfb',GradientType=0 );

  border-radius: 10px;
  position: relative;
  z-index: 9999;
}

.resulttype1 .numtiles-cont:after {
  background: url("/images/numtiles-cont-element.png") no-repeat;
  background-size: cover;
  width: 4px;
  height: 121px;
  position: absolute;
  right: 0;
  top: 30px;
  content: "";
}

.resulttype1 .numtiles-cont:before {
  background: url("/images/numtiles-cont-element.png") no-repeat;
  background-size: cover;
  width: 4px;
  height: 121px;
  position: absolute;
  left: 0;
  top: 30px;
  content: "";
}

.resulttype1 .numtiles-cont-space {
  width: 176px;
  height: 176px;
  padding: 8px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.275) !important;
  position: relative;
}

.resulttype1 .tile {
  width: 30px;
  height: 30px;
  line-height: 34px;
  float: left;
  margin: 1px;
  text-align: center;
  font-weight: bold;
  background: #e1e7f6;
  color: #e1e7f6;
  position: relative;
  transition: 0.3s all;
  border-radius: 3px;
  font-family: "Eczar", serif;
}

.resulttype1 .tile:after {
  content: "";
  position: absolute;
  border: 1px solid #a5beff;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  left: 3px;
  top: 3px;
}

.resulttype1 .tile.red:after,
.resulttype1 .tile.black:after {
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.resulttype1 .tile.red,
.summary-item.red {
  background: rgb(250, 89, 79);
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZhNTk0ZiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNiMzE1MzIiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
  background: -moz-linear-gradient(top, rgba(250, 89, 79, 1) 0%, rgba(179, 21, 50, 1) 100%);
  background: -webkit-linear-gradient(top, rgba(250, 89, 79, 1) 0%, rgba(179, 21, 50, 1) 100%);
  background: linear-gradient(to bottom, rgba(250, 89, 79, 1) 0%, rgba(179, 21, 50, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fa594f', endColorstr='#b31532',GradientType=0 );
  color: #fff;
}

.resulttype1 .tile.black,
.summary-item.black {
  background: rgb(66, 74, 82);
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzQyNGE1MiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMzMzNhNDAiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
  background: -moz-linear-gradient(top, rgba(66, 74, 82, 1) 0%, rgba(51, 58, 64, 1) 100%);
  background: -webkit-linear-gradient(top, rgba(66, 74, 82, 1) 0%, rgba(51, 58, 64, 1) 100%);
  background: linear-gradient(to bottom, rgba(66, 74, 82, 1) 0%, rgba(51, 58, 64, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#424a52', endColorstr='#333a40',GradientType=0 );
  color: #fff;
}

.resulttype1 .summary-detail {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  line-height: 26px;
  border-radius: 4px;
  padding: 5px 3px 5px 34px;
  margin: 0 8px;
  position: relative;
}

.resulttype1 .summary-detail:before {
  content: "";
  position: absolute;
  left: 4px;
  top: 5px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  z-index: 1;
}
.resulttype1 .summary-detail.totalsum {
  padding: 3px 3px;
}
.resulttype1 .summary-detail.totalsum:before {
  background-image: url("/images/sumdet-1.svg");
  display: none;
}

.resulttype1 .summary-detail.row1,
.resulttype1 .summary-detail.row2,
.resulttype1 .summary-detail.row3,
.resulttype1 .summary-detail.row4,
.resulttype1 .summary-detail.row5 {
  background: #d9e8fb;
  color: #3c62a7;
  position: absolute;
  top: 12px;
  left: -28px;
  margin: 0;
  padding: 4px;
  width: 240px;
}

.resulttype1 .summary-detail.row1 .detailvalue,
.resulttype1 .summary-detail.row2 .detailvalue,
.resulttype1 .summary-detail.row3 .detailvalue,
.resulttype1 .summary-detail.row4 .detailvalue,
.resulttype1 .summary-detail.row5 .detailvalue {
  margin-top: 1px;
}

.resulttype1 .summary-detail.row1:before,
.resulttype1 .summary-detail.row2:before,
.resulttype1 .summary-detail.row3:before,
.resulttype1 .summary-detail.row4:before,
.resulttype1 .summary-detail.row5:before {
  left: 2px;
  top: 3px;
  width: 24px;
  height: 24px;
}
.resulttype1 .summary-detail.row2 {
  top: 45px;
}
.resulttype1 .summary-detail.row3 {
  top: 77px;
}
.resulttype1 .summary-detail.row4 {
  top: 109px;
}
.resulttype1 .summary-detail.row5 {
  top: 141px;
}

.resulttype1 .summary-detail.row1:before {
  background-image: url("/images/sumdet-2.svg");
}

.resulttype1 .summary-detail.row2:before {
  background-image: url("/images/sumdet-3.svg");
}

.resulttype1 .summary-detail.row3:before {
  background-image: url("/images/sumdet-4.svg");
}

.resulttype1 .summary-detail.row4:before {
  background-image: url("/images/sumdet-5.svg");
}

.resulttype1 .summary-detail.row5:before {
  background-image: url("/images/sumdet-6.svg");
}

.resulttype1 .detailvalue {
  color: #00499b;
  float: right;
  margin-top: 3px;
  height: 20px;
  line-height: 20px;
  width: 25px;
  text-align: center;
  padding: 0 5px;
}

.resulttype1 .totalsum .detailvalue {
  color: #00fff5;
  float: right;
  margin-top: 3px;
  height: 20px;
  line-height: 20px;
  width: 50px;
  text-align: center;
  padding: 0 5px;
  background: #00499b;
  border-radius: 5px;
}

.resulttype1 .summary-item > span > span {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 20px;
  color: #fff;
}

.resulttype1 .trendstat {
  font-size: 10px;
  padding: 0;
  border-radius: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #759bf8;
  color: #fff;
  float: left;
  margin: 2px 2px;
  width: 52px;
}

.resulttype2 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype2 .theresult .trendsnumber {
  display: flex;
  width: 100%;
  height: auto;
  margin: 0 auto 10px;
  position: relative;
  background: #393535;
  border-radius: 6px;
  padding: 4px;
}

.resulttype2 .trendsnumber .tile {
  width: 22px;
  height: 22px;
  line-height: 22px;
  margin: 4px 1px;
  border-radius: 22px;
}

.resulttype2 .trendsnumber .tile > span {
  display: block;
  margin: 2px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 24px;
  background: #2074fe;
  color: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
}

.resulttype2 .trendsnumber .tile > span.lighter {
  background: #36c1ff;
}
/*tessting*/
.resulttype2 .theresult .sum {
  display: block;
  padding: 10px 0 5px 0;
  font-size: 16px;
  font-weight: bold;
  color: #f6d7a2;
}

.resulttype2 .theresult .sum {
  background: transparent url(/images/trendsumbg.png) center center no-repeat;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
  height: 40px;
  padding: 0;
}

.resulttype2 .trendstat {
  font-size: 10px;
  padding: 0;
  border-radius: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  /*background: #105aa2;*/
  background: #1f73fd;

  color: #ffffff;
  display: inline-block;
  margin: 5px 1% 5px 1%;
  width: 31%;
}

.page-item.active .page-link {
  background-color: #11487e;
  border-color: #11487e;
}

/*NUMBER*/
.resulttype3 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype3 .theresult .circle-number {
  display: flex;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  padding: 0 20px 0 20px;
}

.resulttype3 .theresult .cir-lay-one {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  width: 89px;
  height: 89px;
  border-radius: 50%;
}

.resulttype3 .theresult .cir-lay-two {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #22b3f3;
}

.resulttype3 .theresult .cir-lay-thr {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #02324b;
}

.resulttype3 .theresult .four {
  display: flex;
  justify-content: center;
  align-items: center;
  background: -moz-linear-gradient(top, #08dffe 0%, #0e6fdd 100%);
  background: -webkit-linear-gradient(top, #08dffe 0%, #0e6fdd 100%);
  background: linear-gradient(to bottom, #08dffe 0%, #0e6fdd 100%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  position: relative;
}

.resulttype3 .theresult .four.redball {
  background: -moz-linear-gradient(top, #ff7995 0%, #d32349 100%);
  background: -webkit-linear-gradient(top, #ff7995 0%, #d32349 100%);
  background: linear-gradient(to bottom, #ff7995 0%, #d32349 100%);
}

.resulttype3 .theresult .four.blueball {
  background: -moz-linear-gradient(top, #08dffe 0%, #0e6fdd 100%);
  background: -webkit-linear-gradient(top, #08dffe 0%, #0e6fdd 100%);
  background: linear-gradient(to bottom, #08dffe 0%, #0e6fdd 100%);
}

.resulttype3 .theresult .four .four-text span {
  content: "";
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  line-height: 30px;
  background: #fff;
  color: #000;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  position: absolute;
  top: 7px;
  left: 7px;
  right: 7px;
  bottom: 7px;
}

.resulttype3 .theresult .four-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #004f7a;
}

.resulttype3 .theresult .four-text {
  color: white;
  font-weight: bold;
  font-size: 25px;
}

.resulttype3 .theresult .result-rows {
  margin: 10px 13px 0 13px;
  align-items: center;
  align-content: center;
}

.resulttype3 .theresult .second-row-number {
  margin-bottom: 7px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.resulttype3 .theresult .result_number {
  margin: 5px 1% 5px 1%;
  font-size: 10px;
  padding: 0;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #105aa2;
  border-radius: 16px;
  color: #fff;
  width: 48%;
  display: block;
  position: relative;
  float: left;
}

/*Tai Xiu*/
.resulttype4 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype4 .theresult .bet-history-summary {
  margin: 10px;
  color: white;
  text-align: center;
  display: flex;
}

.resulttype4 .theresult .bet-history-summary-dices {
  flex: 1;
  position: relative;
  display: block;
}

.resulttype4 .theresult .bet-history-summary-figures {
  width: 72px;
}

.resulttype4 .theresult .bet-history-summary-sum-title {
  color: white;
  font-size: 12px;
}

.resulttype4 .theresult .bet-history-summary-figures-card {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #342f2f;
  font-weight: bold;
}

.resulttype4 .theresult .bet-history-summary-dices-container {
  height: 100%;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resulttype4 .theresult .bet-history-summary-dices-img {
  padding-left: 6px;
  padding-right: 6px;
  display: block;
  width: 33.33333333%;
  float: left;
}

.resulttype4 .theresult .bet-history-summary-dices-row {
  margin-left: -6px;
  margin-right: -6px;
}

.resulttype4 .theresult .bet-history-summary-dices-img img {
  vertical-align: unset;
  border-style: none;
  width: 100%;
}

/*UP DOWN*/
.resulttype5 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype5 .theresult .history-summary {
  display: flex;
  padding: 13px 15px;
}

.resulttype5 .theresult .history-summary-cards {
  flex: 1;
  position: relative;
  display: block;
}

.resulttype5 .theresult .history-summary-cards-container {
  height: 100%;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resulttype5 .theresult .current-cards-first {
  margin-left: 15px;
  padding-left: 6px;
  padding-right: 6px;
  display: block;
  width: 50%;
}

.resulttype5 .theresult .summary-cards-second {
  margin-left: -42px;
  margin-top: 15px;
  padding-left: 6px;
  padding-right: 6px;
  display: block;
  width: 50%;
}

.resulttype5 .theresult .history-summary-hi-lo {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #f0f0f0;
  font-weight: bold;
  margin-top: 15px;
  color: black;
  display: flex;
  justify-content: center;
}

.resulttype5 .theresult .history-summary-black-red {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #f0f0f0;
  font-weight: bold;
  display: flex;
  justify-content: center;
}

.resulttype5 .theresult .history-summary-black-red.R {
  color: red;
}
.resulttype5 .theresult .history-summary-black-red.B {
  color: black;
}
.resulttype5 .theresult .history-summary-black-red.J {
  color: #4ebaf1;
}

.resulttype5 .theresult .history-summary-cards-row {
  margin-left: -6px;
  margin-right: -6px;
  display: flex;
}

.resulttype5 .theresult .previous-card {
  vertical-align: unset;
  background: black;
  border-radius: 10%;
  opacity: 0.7;
  width: 100%;
}

.resulttype5 .theresult .current-card {
  vertical-align: unset;
  background: black;
  border-radius: 10%;
  width: 100%;
  position: relative;
}

.resulttype5 .theresult .bet-history-summary-figures {
  width: 72px;
}

/*Domino*/
.resulttype6 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype6 .theresult .history-summary {
  display: flex;
  padding: 13px 15px;
}

.resulttype6 .theresult .history-summary-cards-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.resulttype6 .theresult .history-player-text {
  color: #4ebaf1;
  font-weight: 800;
  margin-bottom: 3px;
  text-align: center;
  display: block;
  width: 41.66666667%;
  float: left;
  position: relative;
  text-transform: uppercase;
}

.resulttype6 .theresult .space {
  display: block;
  width: 16.66666667%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .history-banker-text {
  color: #ff5050;
  font-weight: 800;
  margin-bottom: 3px;
  text-align: center;
  display: block;
  width: 41.66666667%;
  float: left;
  position: relative;
  text-transform: uppercase;
}

.resulttype6 .theresult .summary-cards-row {
  margin-left: -4px;
  margin-right: -4px;
  display: flex;
}

.resulttype6 .theresult .current-cards-player-first {
  padding-left: 4px;
  padding-right: 4px;
  display: block;
  width: 20.83333333%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .summary-cards-player-second {
  padding-left: 4px;
  padding-right: 4px;
  display: block;
  width: 20.83333333%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .summary-cards-banker-first {
  padding-left: 4px;
  padding-right: 4px;
  display: block;
  width: 20.83333333%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .summary-cards-banker-second {
  padding-left: 4px;
  padding-right: 4px;
  display: block;
  width: 20.83333333%;
  float: left;
  position: relative;
}

.resulttype6 .theresult img {
  vertical-align: unset;
  border-style: none;
  width: 100%;
}

.resulttype6 .theresult .summary-cards-vs {
  margin-top: 30px;
  text-align: center;
  font-weight: bold;
  padding-left: 4px;
  padding-right: 4px;
  display: block;
  width: 16.66666667%;
  float: left;
  position: relative;
  color: white;
}

.resulttype6 .theresult .history-row {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  height: auto;
  zoom: 1;
  display: block;
}

.resulttype6 .theresult .history-player-sum {
  text-align: center;
  color: #4ebaf1;
  font-weight: 800;
  margin-top: 3px;
  display: block;
  width: 41.66666667%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .history-banker-sum {
  text-align: center;
  color: #ff5050;
  font-weight: 800;
  margin-top: 3px;
  display: block;
  width: 41.66666667%;
  float: left;
  position: relative;
}

.resulttype6 .theresult .domino-result-pb {
  text-align: center;
  font-weight: bold;
  color: black;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 6px;
  margin: 15px 6px 15px 6px;
  height: auto;
  zoom: 1;
  display: block;
  width: 100%;
}

.resulttype6 .theresult .domino-result-player-col {
  padding-left: 6px;
  padding-right: 6px;
  display: block;
  width: 50%;
  float: left;
  position: relative;
  text-transform: uppercase;
  color: white;
}

.resulttype6 .theresult .domino-result-player {
  text-align: center;
  margin: 5px;
  margin-left: -6px;
  margin-right: -6px;
  height: auto;
  zoom: 1;
  display: block;
}

.resulttype6 .theresult .domino-result-banker-col {
  padding-left: 6px;
  padding-right: 6px;
  display: block;
  width: 50%;
  float: left;
  position: relative;
  text-transform: uppercase;
  color: white;
}

.resulttype6 .theresult .domino-result-banker {
  text-align: center;
  margin: 5px;
  margin-left: -6px;
  margin-right: -6px;
  height: auto;
  zoom: 1;
  display: block;
}

.resulttype6 .theresult .the-cards {
  position: relative;
  display: block;
}

.resulttype6 .theresult .the-cards-row {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  height: auto;
  zoom: 1;
  display: block;
}

/*Thai Lotto*/
.resulttype7 .theresult{
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  /*background: #464243 url(/images/historyBG.png) top center no-repeat;*/

  border: 0;
}

.resulttype7 .theresult .lottery-result{
  display: flex;
  /*background: #022640;*/
  /*background: #3F465E;*/
}

.resulttype7 .theresult .result{
  margin: 0px !important;
  width: 100%;
  position: relative;
  height: auto;
  zoom: 1;
  display: block;
}


.resulttype7 .theresult .history-summary{
  padding: 13px 0;
  justify-content: center;
  display: flex;
/*    flex-direction: row;
flex-wrap: wrap;*/
color: #fff;
}

.resulttype7 .theresult .history-summar-cards {
  width: 100%;
  position: relative;
  display: block;
}


.resulttype7 .theresult .history-summary-cards-container{
  display: flex;
/*     flex-direction: row;
flex-wrap: wrap;*/
}

.resulttype7 .theresult .the-cards{
  position: relative;
  display: block;
}

.resulttype7 .theresult .flex{
  display: flex;
}

.resulttype7 .theresult .current-cards-first{
  position: relative;
  display: block;
}

.resulttype7 .theresult .result-one{
  width: 70px;
  height: 70px;
}

.resulttype7 .theresult .lottery-result-pb {
  font-weight: 700;
  color: #fff;
  font-size: 18px;
}

.resulttype7 .theresult .remth-txt{
  text-align: center;
  display: block;
  width: 100%;
  float: left;
  flex: 0 0 auto;
  position: relative;
}

.resulttype7 .theresult .current-cards-second{
  padding: 10px 10px 10px 25px;
  position: relative;
  display: block;
}

.resulttype7 .theresult .cat-result{
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  font-family: Roboto;
}

.resulttype7 .theresult .rank{
  width:30px;display:inline-block;
}

.resulttype7 .theresult .lottery-bigsmall-oddeven {
  text-align: center;
  margin: 5px;
/*    margin-left: -10px;
margin-right: -10px;*/
margin-left: 0px;
margin-right: 0px;
justify-content: space-around;
display: flex;
}

.resulttype7 .theresult .lottery-bsoe{
  border: 1px solid #fff;
  border-radius: 12px;
  padding: 1px;
  padding-left: 10px;
  padding-right: 10px;
  display: block;
  width: 45.83333333%;
  position: relative;
  float: left;
  flex: 0 0 auto;
}

.resulttype7 .theresult .lottery-fsc{
  border: 1px solid #fff;
  border-radius: 12px;
  padding: 1px;
  margin-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  display: block;
  width: 45.83333333%;
  position: relative;
  float: left;
  flex: 0 0 auto;
}

.resulttype7 .theresult .rank-result{
  font-size: 13px;
  font-family: Roboto;
}

/*Keno War*/

.resulttype8 .theresult{
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
}

.resulttype8 .theresult .history-sum {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
  height: 40px;
  padding: 0;
  background: transparent url(/images/trendsumbg.png) center center no-repeat;
}

.resulttype8 .theresult .number-rows {
  margin-left: -5px;
  margin-right: -5px;
  padding: 5px;
  opacity: 0.9;
  font-size: 12px;
  background: #393535;
  border-radius: 10px;
  text-align: center;
  font-weight: 400;
}

.resulttype8 .theresult .pbtitle {
  font-size: 14px;
  display: block;
  margin-bottom: 5px;
  color: #fff;
  font-weight: 400;
}

.resulttype8 .theresult .first-row-number {
  margin-bottom: 7px;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;   
}

.resulttype8 .theresult .result-rows {
  /*margin: 10px 13px 0 13px;*/
  align-items: center;
  align-content: center;
}

.resulttype8 .theresult .second-row-number{
  margin-bottom: 7px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.resulttype8 .theresult .result_number{
  margin: 5px 1% 5px 1%;
  font-size: 10px;
  padding: 0;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #1f73fd;
  border-radius: 16px;
  color: #fff;
  width: 31%;
  display: block;
  position: relative;
  float: left;
}

.resulttype8 .theresult .player-row{
  height: 23px;
  width: 23px;
  margin: 1px;
  line-height: 20px;
  border-radius: 23px;
  background: #105aa2;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  display: block;
  float: left;
  position: relative;
  background: url(/images/kenowar/BlueBall2.jpg);
  background-repeat: no-repeat;
  background-size: contain;
}

.resulttype8 .theresult .banker-row{
  height: 23px;
  width: 23px;
  margin: 1px;
  line-height: 20px;
  border-radius: 23px;
  background: #349dff;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  display: block;
  float: left;
  position: relative;  
  background: url(/images/kenowar/RedBall2.png);
  background-repeat: no-repeat;
  background-size: contain;
}

/*Max Racing PK10*/
.resulttype9 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  /* display: none; */
  /* position: absolute; */
  /* left: 10%;
  top: 10%; */
  /* width: 80%; */
  height: 310px;
  /* overflow: hidden; */
  /* background-size: cover; */
}

.resulttype9 .theresult .section-result-wrapper {
  width: 100%;
}

.resulttype9 .theresult .animation-result-title {
  width: 100%;
  text-align: center;
  padding-top: 18px;
  font-weight: 500;
  color: #fff;
  font-size: 14px;
}

.resulttype9 .theresult .rounds-wrapper {
  width: 100%;
  padding: 8px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  padding: 8px 25px;
}

.resulttype9 .theresult .rounds {
  width: 22px;
  height: 22px;
  border-radius: 19px;
  background: #254a83;
  display: inline-block;
  border: 2px solid #112f4d;
  text-align: center;
  color: #fff;
  font-size: 11px;
  line-height: 19px;
  position: relative;
}

.resulttype9 .theresult .star-image {
  position: absolute;
  top: -5px;
}

.resulttype9 .theresult .trophy-wrapper {
  text-align: center;
  height: 130px;
}

.resulttype9 .theresult .champion-car {
  position: relative;
  display: inline-block;
  top: -36px;
  left: -18px;
  color: #ffad29;
  font-size: 16px;
}

.resulttype9 .theresult .runnerup-car {
  position: relative;
  display: inline-block;
  top: -34px;
  right: -18px;
  color: #afafaf;
  font-size: 16px;
}
.resulttype9 .theresult .test {
  right: 28px;
  position: absolute;
  width: 15px;
  height: 15px;
  background: transparent;
  /* content: "1"; */
  line-height: 12px;
  border-radius: 15px;
  border: 2px solid black;
  color: aliceblue;
  top: 8px;
  font-size: 10px;
}
.resulttype9 .theresult .champion-result-container {
  text-align: center;
  width: 80%;
  background: #112f4d;
  position: relative;
  left: 10%;
  height: 39px;
  display: block;
  text-align: right;
}

.resulttype9 .theresult .champion-runner-result-container {
  margin-top: 10px;
  text-align: center;
  width: 80%;
  background: #112f4d;
  position: relative;
  left: 10%;
  height: 39px;
  display: block;
  text-align: right;
}

.resulttype9 .theresult .champion-result {
  text-align: center;
  background: #102a45;
  display: inline-block;
  height: 27px;
  top: 6px;
  /* width: 34%; */
  width: 32%;
  color: white;
  font-size: 12px;
  line-height: 27px;
  border-radius: 3px;
  margin-top: 6px;
  margin-right: 6px;
}

.resulttype9 .theresult .champion-result-number {
  display: inline-block;
  display: inline-block;
  height: 27px;
  top: 6px;
  /* width: 6%; */
  /* margin-top: 6px;
  margin-right: 6px; */
  color: #d4af37;
  font-size: 14px;
  line-height: 27px;
  border-radius: 3px;
  text-align: center;
  font-weight: 900;
  /* margin-left: 5px; */
}

.resulttype9 .theresult .trophy-result-image {
  text-align: center;
  /* display: inline-block; */
  /* width: 26px; */
  /* height: 26px; */
  width: 12px;

  position: relative;
  left: 0;
  top: 5px;
}

.resulttype9 .theresult .champion-result-image {
  position: absolute;
}

.resulttype9 .theresult .champion-runner-result {
  text-align: center;
  background: #102a45;
  display: inline-block;
  height: 27px;
  top: 6px;
  width: 20%;
  color: white;
  font-size: 12px;
  line-height: 27px;
  border-radius: 3px;
  right: 6px;
  margin-top: 6px;
  margin-right: 4px;
}

.resulttype9 .theresult .max-racing-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 100;
}

/*Fantan*/
.resulttype10 .theresult {
  background: #464243 url(/images/popoverbg.png) top center no-repeat;
  border: 0;
  width: 250px;
  height: auto;
  padding: 10px;
  border-radius: 10px;
}

/*.resulttype10 .history-row {
  width: 210px;
  }*/

  .resulttype10 .history-popper-header {
    padding: 13px 15px;
    opacity: 0.9;
    font-size: 12px;
    padding-bottom: 0px;
  }

  .resulttype10 .history-title {
    text-transform: uppercase;
    color: $hilo-trend-lot-color-1;
    font-size: 14px;
  }

  .resulttype10 .history-draw-no {
    color: white;
    display: block;
    font-size: 12px;
  }

  .resulttype10 .history-total-result {
    color: white;
    margin: 2px;
    padding: 2px;
    text-align: center;
    font-size: 16px;
  }

  .resulttype10 .history-small-title {
    color: white;
    text-align: center;
  }

/*.resulttype10 .history-popper-content {
  padding: 10px;
  padding-top: 2px;
  }*/

  .resulttype10 .history-fan,
  .resulttype10 .history-oe,
  .resulttype10 .history-ssh,
  .resulttype10 .history-kwok,
  .resulttype10 .history-nim,
  .resulttype10 .history-nga {
    padding: 4px;
    text-align: center;
    font-size: 12px;
    background: rgba(0,0,0,.25);
    border: .5px solid hsla(0,0%,100%,.25);
    border-radius: 8px;
    margin: 5px 2px;
    overflow: hidden;
    width: 48%;
    display: inline-block;
    color: white;
  }

  .resulttype10 .history-fan1{
    color: #c9c9c9;
  }

  .resulttype10 .history-fan2{
    color: #16cc86;
  }

  .resulttype10 .history-fan3{
    color: #f9cb62;
  }

  .resulttype10 .history-fan4{
    color: #fa4358;
  }

  .resulttype10 .history-oe12{
    color: #f27728;
  }


  .resulttype10 .history-nim,
  .resulttype10 .history-nga,
  .resulttype10 .history-ssh {
    width: 31.5%;
  }

  .resulttype10 .history-summary-cards.ivu-col {
    flex: 1;
  }

  .resulttype10 .history-summary.ivu-row-flex {
    margin: 10px;
  }

  .resulttype10 .history-summary-cards-container {
    height: 100%;
    padding: 4px 8px;
  }

  .resulttype10 .summary-cards-first {
    margin-left: 15px;
  }

  .resulttype10 .summary-cards-second {
    margin-left: -40px;
    margin-top: 15px;
  }

  .resulttype10 .current-card {
    background: black;
    border-radius: 10%;
  }

  .resulttype10 .previous-card {
    background: black;
    border-radius: 10%;
    opacity: 0.7;
  }

  .resulttype10 .history-summary-result-time {
    font-size: 12px;
    margin-top: 5px;
  }

  .resulttype10 .history-summary-hi-lo {
    width: 100%;
    border-radius: 8px;
    padding: 6px;
    margin: 4px 0;
    background-color: #f0f0f0;
    font-weight: bold;
    margin-top: 15px;
    color: black;
  }

  /*thai hilo */
  .resulttype11 .theresult {
    background: #464243 url(/images/popoverbg.png) top center no-repeat;
    border: 0;
    width: 250px;
    height: auto;
    padding: 10px;
    border-radius: 10px;
  }

  .resulttype11 .bet-history-result {
    text-align: center;
    margin: 15px 0;
    color: white;
  }

  .resulttype11 .bet-history-result {
    text-align: center;
    margin: 15px 0;
  }

  .resulttype11 img {
    width: 80%;
  }

  .resulttype11 .bet-history-summary-dices-row {
    width: 230px;
  }

  .resulttype11 .bet-history-summary-dices-img {
    display: inline-block;
    width: 32%;
    text-align: center;
  }

  /* AtomWar */
  .resulttype12 .theresult {
    width: 250px;
    height: 265px;
    background: #303f65;
    padding: 10px;
    border-radius: 10px;
  }

  .resulttype12 .draw-cont {
    border-radius: 10px;
    width: 100%;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
  }

  .resulttype12 .numtiles-cont {
    width: 108px;
    height: 108px;
    padding: 4px;
    background: rgb(64, 107, 213);
    border-radius: 10px;
    position: relative;
    z-index: 9999;
  }

  .resulttype12 .numtiles-cont:after {
    background: url("/images/numtiles-cont-element.png") no-repeat;
    background-size: cover;
    width: 4px;
    height: 60px;
    position: absolute;
    right: 0;
    top: 30px;
    content: "";
  }

  .resulttype12 .numtiles-cont:before {
    background: url("/images/numtiles-cont-element.png") no-repeat;
    background-size: cover;
    width: 4px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 30px;
    content: "";
  }

  .resulttype12 .numtiles-cont-space {
    width: 100px;
    height: 100px;
    padding: 2px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.275) !important;
    position: relative;
  }

  .resulttype12 .tile {
    width: 30px;
    height: 30px;
    line-height: 34px;
    float: left;
    margin: 1px;
    text-align: center;
    font-weight: bold;
    background: #e1e7f6;
    color: #e1e7f6;
    position: relative;
    /*transition: 0.3s all;*/
    border-radius: 3px;
    font-family: "Eczar", serif;
  }

  .resulttype12 .tile:after {
    content: "";
    position: absolute;
    border: 1px solid #a5beff;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    left: 3px;
    top: 3px;
  }

  .resulttype12 .tile.red:after,
  .resulttype12 .tile.black:after {
    border: 1px solid rgba(255, 255, 255, 0.4);
  }

  .resulttype12 .tile.red,
  .resulttype12 .summary-item.red {
    background: rgb(250, 89, 79);
    color: #fff;
  }

  .resulttype12 .tile.black,
  .resulttype12 .summary-item.black {
    background: rgb(66, 74, 82);
    color: #fff;
  }

  .resulttype12 .summary-detail {
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    line-height: 26px;
    border-radius: 4px;
    padding: 5px 3px 5px 34px;
    margin: 0 8px;
    position: absolute;
    top: 100px;
    left: 6px;
  }

  .resulttype12 .summary-detail.banker {
    left: 130px;
  }

  .resulttype12 .summary-detail:before {
    content: "";
    position: absolute;
    left: 4px;
    top: 5px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  }
  .resulttype12 .summary-detail.totalsum {
    padding: 2px 3px;
  }
  .resulttype12 .summary-detail.totalsum:before {
    display: none;
  }
  .resulttype12 .summary-detail.row1,
  .resulttype12 .summary-detail.row2,
  .resulttype12 .summary-detail.row3,
  .resulttype12 .summary-detail.row4,
  .resulttype12 .summary-detail.row5 {
    background: #d9e8fb;
    color: #3c62a7;
    position: absolute;
    top: 12px;
    margin: 0;
    padding: 4px;
    width: 244px;
    left: -30px;
  }

  .resulttype12 .summary-detail.row1 .detailvalue,
  .resulttype12 .summary-detail.row2 .detailvalue,
  .resulttype12 .summary-detail.row3 .detailvalue,
  .resulttype12 .summary-detail.row4 .detailvalue,
  .resulttype12 .summary-detail.row5 .detailvalue {
    margin-top: 1px;
  }

  .resulttype12 .summary-detail.row1:before,
  .resulttype12 .summary-detail.row2:before,
  .resulttype12 .summary-detail.row3:before,
  .resulttype12 .summary-detail.row4:before,
  .resulttype12 .summary-detail.row5:before {
    left: 4px;
    top: 3px;
    width: 24px;
    height: 24px;
  }
  .resulttype12 .summary-detail.row2 {
    top: 45px;
  }
  .resulttype12 .summary-detail.row3 {
    top: 77px;
  }
  .resulttype12 .summary-detail.row4 {
    top: 109px;
  }
  .resulttype12 .summary-detail.row5 {
    top: 141px;
  }

  .resulttype12 .summary-detail.row1:before {
    background-image: url("/images/sumdet-2.svg");
  }

  .resulttype12 .summary-detail.row2:before {
    background-image: url("/images/sumdet-3.svg");
  }

  .resulttype12 .summary-detail.row3:before {
    background-image: url("/images/sumdet-4.svg");
  }

  .resulttype12 .summary-detail.row4:before {
    background-image: url("/images/sumdet-5.svg");
  }

  .resulttype12 .summary-detail.row5:before {
    background-image: url("/images/sumdet-6.svg");
  }

  .resulttype12 .totalsum .detailvalue {
    color: #00fff5;
    float: right;
    margin-top: 3px;
    height: 20px;
    line-height: 20px;
    width: 30px;
    text-align: center;
    padding: 0 5px;
    background: #00499b;
    border-radius: 5px;
  }

  .resulttype12 .detailvalue {
    color: #00499b;
    float: right;
    margin-top: 3px;
    height: 20px;
    line-height: 20px;
    width: 22px;
    text-align: center;
    padding: 0 5px;
  }

  .resulttype12 .trendstat {
    font-size: 10px;
    padding: 0;
    border-radius: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #759bf8;
    color: #fff;
    float: left;
    margin: 5px 4px 0 0;
    width: 52px;
  }
  .resulttype12 .trendstat-winner {
    font-size: 10px;
    padding: 0;
    border-radius: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #759bf8;
    color: #fff;
    float: left;
    margin: 5px 5px 0 0;
    width: 220px;
  }

  .resulttype12 .result-rows {
    /* padding: 0px 15px 12px; */
    position: absolute;
    top: 179px;
    font-size: 12px;
    color: #fff;
    padding-left: 4px;
  }

  .resulttype12 .result-rows-winner {
    padding: 0px 4px 12px;
    font-size: 12px;
    color: #fff;
    position: absolute;
    top: 130px;
    margin-top: 12px;
  }

  /*Sedie*/
  .resulttype13 .theresult {
    background: #464243 url(/images/popoverbg.png) top center no-repeat;
    border: 0;
    width: 250px;
    height: auto;
    padding: 10px;
    border-radius: 10px;
  }

  .resulttype13 .theresult .result-button {
    width: 20%;
  }

  .resulttype13 .theresult .se-die-result-button {
    text-align: center;
  }

  .resulttype13 .theresult .se-die-oe {
    text-align: center;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.2);
    color: #f0f0f0;
    border-radius: 8px;
    padding: 6px;
    margin: 10px 15px 0px 15px;
    font-weight: bold;
  }

  /*Keno Soccer*/
  .resulttype14 .theresult {
    background: #464243 url(/images/popoverbg.png) top center no-repeat;
    border: 0;
  }

  .resulttype14 .theresult .history-sum {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    height: 40px;
    padding: 0;
    background: transparent url(/images/trendsumbg.png) center center no-repeat;
  }

  .resulttype14 .theresult .number-rows {
    margin-left: -5px;
    margin-right: -5px;
    padding: 5px;
    opacity: 0.9;
    font-size: 12px;
    background: #393535;
    border-radius: 10px;
    text-align: center;
    font-weight: 400;
  }

  .resulttype14 .theresult .pbtitle {
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
    color: #fff;
    font-weight: 400;
  }

  .resulttype14 .theresult .first-row-number {
    margin-bottom: 7px;
    justify-content: space-between;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .resulttype14 .theresult .result-rows {
    margin: 10px 13px 0 13px;
    align-items: center;
    align-content: center;
  }

  .resulttype14 .theresult .second-row-number {
    margin-bottom: 7px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .resulttype14 .theresult .result_number {
    margin: 5px 1% 5px 1%;
    font-size: 10px;
    padding: 0;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #1f73fd;
    border-radius: 16px;
    color: #fff;
    width: 31%;
    display: block;
    position: relative;
    float: left;
  }

  .resulttype14 .theresult .hatitle {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-size: 12px;
    margin: 3.5px;
    color: #fff;
    font-weight: bold;
  }

  .resulttype14 .theresult .home-row {
    height: 23px;
    width: 23px;
    margin: 1px;
    line-height: 21px;
    border-radius: 23px;
    background: url('/images/kenosoccer/BlueShirt.png');
    background-size: cover;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    display: block;
    float: left;
    position: relative;
  }

  .resulttype14 .theresult .away-row {
    height: 23px;
    width: 23px;
    margin: 1px;
    line-height: 21px;
    border-radius: 23px;
    background: url(/images/kenosoccer/RedShirt.png);
    background-size: cover;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    display: block;
    float: left;
    position: relative;
  }

  .resulttype20 .theresult{
    background: #464243 url(/images/popoverbg.png) top center no-repeat;
    border: 0;
    width: 250px;
    height: auto;
    /*padding: 10px;*/
    border-radius: 10px; 
  }

  .resulttype20 .theresult .result {
    text-align: center;
    padding: 10px 0px 0px 0px;
    display: flex;
  }


  .resulttype20 .theresult .result-main {
    display: flex;
    justify-content: space-around;
    padding: 16px 0px 12px 0px;
  }

  .resulttype20 .theresult .result-main-inner {
    width: 67px;
    text-align: center;
    padding: 5px;
    background: #2C2C2C 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 0px #0000004D;
    border: 1px solid #FFEA75;
    border-radius: 13px;
    opacity: 1;
    font: normal normal normal 13px Arvo;
    letter-spacing: 0.26px;
    color: #FFEA75;
    margin: 0px 1px 0px 1px;
  }

  .resulttype20 .theresult .result-num{
    border-radius: 100px;
    box-shadow: 0px 1px 0px #0000004D;
    width: 46px;
    height: 46px;
    text-align: center;
    font: normal normal normal 22px/46px Arvo;
    letter-spacing: 0.44px;
    color: #FFFFFF;
    opacity: 1;
    margin: 0 auto;
  }

  .resulttype20 .theresult .result-flex{
    flex:1;
  }

  .resulttype20 .theresult .result-sub-num{
    border-radius: 100px;
    box-shadow: 0px 1px 0px #0000004D;
    width: 39px;
    height: 39px;
    text-align: center;
    font: normal normal normal 18px/40px Arvo;
    letter-spacing: 0.36px;
    color: #FFFFFF;
    opacity: 1;
    margin: 0 auto;
  }

  .resulttype20 .theresult .green{
    border-radius: 100px;
    background: #389059 0% 0% no-repeat padding-box;
  }

  .resulttype20 .theresult .blue{
    border-radius: 100px;
    background: #4B7FC2 0% 0% no-repeat padding-box;

  }

  .resulttype20 .theresult .red{
    border-radius: 100px;
    background: #C04C56 0% 0% no-repeat padding-box;
  }
.lrspan{
        display: flex;
        justify-content: space-between;
    }




</style>


